/** Тип дорожного события между точками. */
export enum CityQuestRouteEventTypeEnum {
    /** Сообщение по сюжету, без задания. */
    MESSAGE = 'message',
    /** Бонусное задание без таймера. */
    THEFT_BONUS = 'theft_bonus',
    /** Бонусное задание на время (softTimerSeconds). */
    TIMED_CHALLENGE = 'timed_challenge',
    /**
     * GPS-погоня: виртуальная цель движется рядом с игроком, её надо
     * догнать за отведённое время. Конфиг — в chase, исход клиент
     * репортит через chase-result.
     */
    GPS_CHASE = 'gps_chase',
}
